import "@fontsource/ibm-plex-sans-arabic/400.css";
import "@fontsource/ibm-plex-sans-arabic/500.css";
import "@fontsource/ibm-plex-sans-arabic/600.css";
import "@fontsource/ibm-plex-sans-arabic/700.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.jsx";
import "./styles.css";
import "../../n9-workspace-platform/shared/platform-ui.css";
import {PlatformBroadcasts} from '../../n9-workspace-platform/shared/PlatformBroadcasts.jsx';

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <PlatformBroadcasts />
    <App />
  </React.StrictMode>,
);
